export default "__VITE_ASSET__tJEOqVpk__"